import { colorPalet } from "./colorPalet";

export const ROUTE = {
  HOME: "/",
};

export const URLS = {
  TYKR: "https://tykr.com",
  TYKR_SIGNUP: "https://app.tykr.com/signup",
  TYKR_LOGIN: "https://app.tykr.com",
  TYKR_CALCULATION: "https://tykr.com/calculations/",
  PROFILE_FACEBOOK: "https://www.facebook.com/tykrpro/",
  PROFILE_INSTAGRAM: "https://www.instagram.com/tykrinvest/",
  PROFILE_YOUTUBE: "https://www.youtube.com/c/tykr-investing",
  BASE_URL: "https://tykr.com/stocks",
};

export const GENERAL_TEXT = {
  RETIREMENT_CALCULATOR: "Retirement Calculator",
  PORTFOLIO_TRACKER: "Portfolio Tracker",
  WATCHLIST: "Watchlist",
  FILL_THE_FORM: "Complete the form to see if you're on track to retire!",
  CONTINUE: "Continue",
  START_INVESTING: "Start investing",
  START_INVESTING_FOR_FREE: "Start investing for free",
  SUMMARY: "Summary",
  SCORE: "Score",
  FOURM: "4M Confidence Booster",
  MOS: "Margin of Safety",
  FETCH_POLICY: "cache-and-network",
};

export const CHART_LINE = [
  {
    name: "Future Portfolio Value",
    color: colorPalet.tykrFairValue,
  },
  {
    name: "Your Contributions",
    color: colorPalet.brandGreen,
  },
  {
    name: "Portfolio Burndown",
    color: colorPalet.error,
  },
];

export const CONTENT_DATA = [
  {
    title: "See if you are on track to retire!",
    buttonText: GENERAL_TEXT.RETIREMENT_CALCULATOR,
  },
  {
    title:
      "See the rating of your portfolio compared to other investors in the market.",
    buttonText: GENERAL_TEXT.PORTFOLIO_TRACKER,
  },
];

export const HOW_TO_USE = [
  {
    label: "On Sale",
    className: "potential_buy potential_onsale",
    note: "Tykr Score is 50 or higher and MOS is 50% or higher.",
  },
  {
    label: "Watch",
    className: "potential_hold",
    note: "Either the Tykr Score or MOS is above 50 while the other is below 50.",
  },
  {
    label: "Overpriced",
    className: "potential_sell",
    note: "Both the Tykr Score and MOS are below 50.",
  },
];

export const PROJECTION_LINE = [
  {
    name: "Tykr Fair Value",
    color: colorPalet.tykrFairValue,
    lightColor: colorPalet.tykrFairValueLight,
    tooltip:
      "The Tykr fair value is calculated with the EPS growth rate which is essentially the profit growth rate of the company.",
  },
  {
    name: "Rule #1 Fair Value",
    color: colorPalet.rule1FairValue,
    lightColor: colorPalet.rule1FairValueLight,
    tooltip:
      "The Rule 1 fair value is what inspired the Tykr fair value. The Rule 1 fair value is also calculated with the EPS growth rate plus the P/E Ratio. In many cases, the Rule 1 projections may be the same as the Tykr projections.",
  },
  {
    name: "Graham Fair Value",
    color: colorPalet.grahamFairValue,
    lightColor: colorPalet.grahamFairValueLight,
    tooltip:
      "The Graham fair is calculated with the bond rate and P/E ratio. This calculation was used close to 100 years ago. Today, projections no longer factor in the bond rate because bonds no longer move the market like they did a century ago. However, some investors still like to see the Graham projections for perspective.",
  },
  {
    name: "Discounted Cash Flow",
    color: colorPalet.textMuted,
    lightColor: colorPalet.borderDivider,
    tooltip:
      "Discounted Cash Flow is a very conservative projection method. It was originally used in the 1700s but since then, companies have figured out how to scale revenue and profits much faster due to the power of technology. Some investors still like to use this projection method but it's important to set expectations that the projections may be low.",
  },
];
export const PROJECTION_COMPARISON_LINE = [
  {
    name: "Share price",
    sortName: "",
    color: colorPalet.tykrFairValueLight,
    lightColor: colorPalet.tykrFairValueLight,
    tooltip: "This is the current share price.",
  },
  {
    name: "Tykr Fair Value",
    sortName: "Tykr",
    color: colorPalet.tykrFairValue,
    lightColor: colorPalet.tykrFairValueLight,
    tooltip:
      "The Tykr fair value is calculated with the EPS growth rate which is essentially the profit growth rate of the company.",
  },
  {
    name: "Rule #1 Fair Value",
    sortName: "Rule #1",
    color: colorPalet.rule1FairValue,
    lightColor: colorPalet.rule1FairValueLight,
    tooltip:
      "The Rule 1 fair value is what inspired the Tykr fair value. The Rule 1 fair value is also calculated with the EPS growth rate plus the P/E Ratio. In many cases, the Rule 1 projections may be the same as the Tykr projections.",
  },
  {
    name: "Graham Fair Value",
    sortName: "Graham",
    color: colorPalet.grahamFairValue,
    lightColor: colorPalet.grahamFairValueLight,
    tooltip:
      "The Graham fair is calculated with the bond rate and P/E ratio. This calculation was used close to 100 years ago. Today, projections no longer factor in the bond rate because bonds no longer move the market like they did a century ago. However, some investors still like to see the Graham projections for perspective.",
  },
  {
    name: "Discounted Cash Flow",
    sortName: "DCF",
    color: colorPalet.dcf,
    lightColor: colorPalet.dcfLight,
    tooltip:
      "Discounted Cash Flow is a very conservative projection method. It was originally used in the 1700s but since then, companies have figured out how to scale revenue and profits much faster due to the power of technology. Some investors still like to use this projection method but it's important to set expectations that the projections may be low.",
  },
];

export const FIELD_TYPES = {
  NUMBER: "number",
  TEXT: "text",
};

export const RETIREMENT_CALCULATOR_FIELDS = [
  {
    name: "currentAge",
    label: "Your Current Age",
    id: "currentAge",
    type: FIELD_TYPES.NUMBER,
    rules: [{ required: true, message: "Please insert your current age" }],
    min: 0,
    className: "w-100",
    onBlur: true,
    disabled: false,
  },
  {
    name: "retirementAge",
    label: "Your Goal Retirement Age",
    id: "goalRetirementAge",
    type: FIELD_TYPES.NUMBER,
    rules: [{ required: true, message: "Please insert your retirement age" }],
    min: 0,
    className: "w-100",
    onBlur: true,
    disabled: false,
  },
  {
    name: "yearsLeftInRetirement",
    label: "Years Left Before Retirement",
    id: "yearsLeftBeforeRetirement",
    type: FIELD_TYPES.NUMBER,
    rules: [],
    min: 0,
    className: "w-100",
    onBlur: true,
    disabled: true,
  },
  {
    name: "yearsInRetirement",
    label: "Years in Retirement",
    id: "yearsInRetirement",
    type: FIELD_TYPES.NUMBER,
    rules: [{ required: true, message: "Please insert years in retirement" }],
    min: 0,
    className: "w-100",
    onBlur: true,
    disabled: false,
  },
];

export const FORM_FIELDS = [
  {
    name: "currentAge",
    rules: [
      { required: true, message: "Please insert your current age" },
      {
        type: "number",
        min: 0,
        max: 100,
        message: "Age must be between 0 and 100",
      },
    ],
  },
  {
    name: "retirementAge",
    rules: [
      { required: true, message: "Please insert your retirement age" },
      {
        type: "number",
        min: 0,
        max: 100,
        message: "Age must be between 0 and 100",
      },
    ],
  },
  {
    name: "inflationRate",
    rules: [
      { required: true, message: "Please insert inflation rate" },
      {
        type: "number",
        min: 0,
        max: 100,
        message: "Rate must be between 0 and 100",
      },
    ],
  },
  {
    name: "name",
    rules: [
      { required: true, message: "Please insert your name" },
      { max: 50, message: "Name must be less than 50 characters" },
    ],
  },
  {
    name: "email",
    rules: [
      { required: true, message: "Please insert your email" },
      { type: "email", message: "Please enter a valid email" },
      { max: 100, message: "Email must be less than 100 characters" },
    ],
  },
];

export const CURRENCY_FIELDS = [
  {
    name: "lifeStyleCostBeforeRetirement",
    id: "lifestyleCostBeforeRetirement",
    label: "Lifestyle Cost Before Retirement",
  },
  {
    name: "currentPortfolio",
    id: "currentPortfolioSize",
    label: "Current Portfolio Size",
  },
  {
    name: "annualContributions",
    id: "annualContributions",
    label: "Annual Contributions",
  },
];

export const PERCENTAGE_FIELDS = [
  {
    name: "returnRateBeforeRetirement",
    id: "rateOfReturnBeforeRetirement",
    label: "Rate of Return Before Retirement",
  },
  {
    name: "returnRateAfterRetirement",
    id: "rateOfReturnAfterRetirement",
    label: "Rate of Return After Retirement",
  },
  {
    name: "inflationRate",
    id: "inflationRate",
    label: "Inflation Rate",
    isLast: true,
  },
];

export const USER_INFO_FIELDS = [
  {
    name: "fullName",
    label: "First Name",
    type: FIELD_TYPES.TEXT,
    rules: [{ required: true, message: "Please insert your name" }],
    placeholder: "Name",
    className: "h-40 w-100",
  },
  {
    name: "email",
    label: "Email",
    type: FIELD_TYPES.TEXT,
    rules: [{ required: true, message: "Please insert your email" }],
    placeholder: "Email",
    className: "h-40 w-100",
  },
];

export const opts = {
  height: "520px",
  width: "100%",
  playerVars: {
    autoplay: 0,
  },
};
